import { SPACING } from 'constants/spacing.constants'
import {
    Circle,
    CircleCheck,
    CircleDollarSign,
    CircleGauge,
    CirclePause,
    CircleSlash,
    CircleX,
    LucideIcon,
    Timer,
} from 'lucide-react'
import { OrderStatusType } from 'types/order.types'
import {
    TEXT_COLORS_MAP,
    BACKGROUND_COLORS_MAP,
    BORDER_COLORS_MAP,
} from './orderStatusChip.constants'
import styled from '@emotion/styled'
import Row from 'components/core/Row'
import { DESIGN_TOKENS } from 'constants/color.constants'

export const ICONS_MAP: Record<OrderStatusType, LucideIcon> = {
    quoting: CircleDollarSign,
    procuring: Timer,
    scheduled: Circle,
    inTransit: CircleGauge,
    delivered: CircleCheck,
    cancelled: CircleX,
    onHold: CirclePause,
    quoteLost: CircleSlash,
}

const StyledContainer = styled(Row)<{ status: OrderStatusType }>`
    width: ${SPACING.p2};
    height: ${SPACING.p2};
    border-radius: ${DESIGN_TOKENS.borderRadius.sm};

    ${(p) => `border: 1px solid ${BORDER_COLORS_MAP[p.status]};`}
`

export type OrderStatusIconProps = {
    status: OrderStatusType
}

export const OrderStatusIcon = ({ status }: OrderStatusIconProps) => {
    const Icon = ICONS_MAP[status]

    return (
        <StyledContainer
            status={status}
            bgColor={BACKGROUND_COLORS_MAP[status]}
            justifyContent="center"
            alignItems="center"
        >
            <Icon size="1.2rem" color={TEXT_COLORS_MAP[status]} />
        </StyledContainer>
    )
}
